import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'

const Font = forwardRef((props, ref) => {
  const { element, className, type, weight, color, ...otherProps } = props,
    classes = [className, styles[type], styles[weight], styles[color]].filter(
      Boolean,
    ), // Remove falsy values
    Component = element

  return <Component ref={ref} className={classes.join(' ')} {...otherProps} />
})

Font.propTypes = {
  element: PropTypes.string,
  type: PropTypes.oneOf([
    'heading',
    'body',
    'bodyLato',
    'caption',
    'inherit',
  ]),
  weight: PropTypes.oneOf(['light', 'regular', 'medium', 'semiBold', 'bold']),
  color: PropTypes.oneOf(['secondary', 'white', 'primary', 'error']),
}

Font.defaultProps = {
  element: 'p',
  type: 'body',
}

Font.displayName = 'Font'

export default Font
